import { addCalendarSourceRequestSchema } from '@borradh-workspace/contracts';
import type { AddIcalSourceInput } from './ical-calendar.input';

export function buildAddIcalSourcePayload(input: AddIcalSourceInput) {
  return addCalendarSourceRequestSchema.strict().parse({
    name: input.kind === 'treatwell' ? 'Treatwell' : input.name,
    kind: input.kind,
    ...(input.kind === 'ical' ? { url: input.url } : {}),
  });
}
